import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45b46fbc&scoped=true"
import script from "./button.js?vue&type=script&lang=js&external"
export * from "./button.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=45b46fbc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b46fbc",
  null
  
)

export default component.exports